import {
    Billing,
    BalanceDetails,
    SingleBillingDetails,
    ProfessionalBillingDetails,
} from 'one-state-billing-details-cerner';

import {format} from 'one-util-date'; 


export const TransformBillingDetailsCerner = (response: any, context: any) => {
    let billingdata: Billing[] = [];
    let billingresult: any = {
        billingdata: billingdata,
        error: undefined
    }
    const { log } = context;
    log.debug("one-epic", "TransformBillingDetails transformation entered", response);
    // TODO:verify backend team check for errors
    if (response && response.status >= 400) {
        billingresult.error = response;
        let billing: Billing = {
            serviceAreaName: "",
            patientsGuarantor: false,
            paperless: false,
            AccountId: "",
            AccountName: "",
            isError: response.status == 500 ? false : true, //The false for 500 is to write a custom error for it separately
            statementnumber: "",
            balanceDetails: undefined,
            singleBillingDetails: undefined,
            noDetails: ""
        }
        billingdata.push(billing)
    }
    if (response && response.length > 0) {
        response.map((ele: any) => {
            if (ele?.GuarantorAccounts?.length > 0) {
                ele.GuarantorAccounts.map((account: any) => {
                    let billing: Billing = {
                        serviceAreaName: "",
                        patientsGuarantor: false,
                        paperless: false,
                        AccountId: "",
                        AccountName: "",
                        isError: false,
                        statementnumber: "",
                        balanceDetails: undefined,
                        singleBillingDetails: undefined,
                        noDetails: ""
                    };

                    let balancelist: BalanceDetails[] = [];
                    let singlebillinglist: SingleBillingDetails[] = [];

                    billing.serviceAreaName = account?.ServiceProvider;
                    billing.patientsGuarantor = account?.PatientIsGuarantor;
                    billing.paperless = account?.IsPaperless;
                    billing.statementnumber = account?.StatementNumber;
                    billing.noDetails = account?.noDetails;
                    if (account?.AccountIDs) {
                        account.AccountIDs.map((element: any) => {
                            if (element.Type === 'INTERNAL') {
                                billing.AccountId = element?.ID;
                            }
                            if (element.Type === 'NAME') {
                                billing.AccountName = element?.ID;
                            }
                        })
                    }

                    let Gobj: BalanceDetails = {
                        type: "Guarantor-Balance",
                        patientBalance: account?.PatientBalance,
                        insuranceBalance: account?.InsuranceBalance ? account?.InsuranceBalance  : "0.00",
                        billedamount:account?.BilledAmount
                    }
                    balancelist.push(Gobj);
                    
                    let Gobj2: SingleBillingDetails = {
                        encounterID: account?.encounterID,
                        admitdate: account?.AdmitDate,
                        accountname: account?.AccountName,
                        locationname: account?.LocationName,
                        servicetype: account?.ServiceType, 
                        patientbalance: account?.PatientBalance ? "$" + account?.PatientBalance : "$0.00",
                        billedamount:  "$" + account?.BilledAmount , //Can remove for cerner as we don't have data
                    }
                    singlebillinglist.push(Gobj2);

                    billing.balanceDetails = balancelist;
                    billing.singleBillingDetails = singlebillinglist;

                    billingdata.push(billing);
                })
            }
        });
    }
    billingresult.billingdata = billingdata;
    log.debug("one-epic", "TransformBillingDetails transformation Completed", billingresult);
 
    return billingresult;
}